import VerifyMagicLinkPage from "~/pages/VerifyMagicLinkPage";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_public/verify")({
  component: VerifyMagicLinkPage,
  validateSearch(search) {
    return z.object({ token: z.string(), oauth_ctx: z.string().optional() }).parse(search);
  },
});
